import { render, staticRenderFns } from "./approveCount.vue?vue&type=template&id=15f62470&scoped=true&"
import script from "./approveCount.vue?vue&type=script&lang=js&"
export * from "./approveCount.vue?vue&type=script&lang=js&"
import style0 from "./approveCount.vue?vue&type=style&index=0&id=15f62470&lang=less&scoped=true&"
import style1 from "./approveCount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f62470",
  null
  
)

export default component.exports